import React, { Fragment } from 'react';
// import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Label from 'reactstrap/lib/Label';
import Input from 'reactstrap/lib/Input';
import Button from 'reactstrap/lib/Button';
import Media from 'reactstrap/lib/Media';

import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';

import closeImg from '../../../images/icons/close.png';

import { PopoverBody, UncontrolledPopover } from 'reactstrap';

class Settings extends React.Component {
  static propTypes = {
  }

  static defaultProps = {
  }

  constructor(props) {
    super(props);
    this.state = {
      // mobileVersion: null,
      // mobileVersionDev: null,
      iosVersion: null,
      iosVersionDev: null,
      androidVersion: null,
      androidVersionDev: null,
      treasureChestEnabled: null,
    };

  }


  componentDidMount() {
    console.log('getStatistic componentDidMount');
    const { getMobileVersion, getTreasureChestEnabled } = this.props;

    getMobileVersion('ios', false).then((res) => {
      this.setState({ iosVersion: res.data });
    });

    getMobileVersion('ios', true).then((res) => {
      this.setState({ iosVersionDev: res.data });
    });

    getMobileVersion('android', false).then((res) => {
      this.setState({ androidVersion: res.data });
    });

    getMobileVersion('android', true).then((res) => {
      this.setState({ androidVersionDev: res.data });
    });

    getTreasureChestEnabled().then((res) => {
      this.setState({ treasureChestEnabled: res.data });
    });
  }

  componentDidUpdate() {

  }

  handleChange = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

    this.setState({
      [event.target.name]: value,
    });
  }

  changeMobileVersion = (platform) => {
    const { setMobileVersion, showNotification } = this.props;
    const { iosVersion, androidVersion } = this.state;
  

    setMobileVersion(platform === 'ios' ? iosVersion : androidVersion, platform, null)
      .then((res) => {
        if (res.status === 'success') {
          showNotification('Success', 'Version updated successfully', 'success');
        } else {
          showNotification('Error!', 'Failed to update version. ' + res.message, 'danger');
        }
      })
      .catch((error) => {
        showNotification('Error!', 'Failed to update version. ' + error, 'danger');
      });
  }

  changeMobileVersionDev = (platform) => {
    const { setMobileVersion, showNotification } = this.props;
    const { iosVersionDev, androidVersionDev } = this.state;

    setMobileVersion(platform === 'ios' ? iosVersionDev : androidVersionDev, platform, true)
      .then((res) => {
        console.log('setMobileVersion', res);

        if (res.status === 'success') {
          showNotification('Success', 'Version updated successfully', 'success');
        } else {
          showNotification('Error!', 'Failed to update version. ' + res.message, 'danger');
        }
      })
      .catch((error) => {
        showNotification('Error!', 'Failed to update version. ' + error, 'danger');
      });
  }

  changeTreasureChestEnabled = () => {
    const { setTreasureChestEnabled } = this.props;
    const { treasureChestEnabled } = this.state;

    setTreasureChestEnabled(treasureChestEnabled);
  }

  render() {
    const {
      t,
    } = this.props;

    const {
      iosVersion,
      iosVersionDev,
      androidVersion,
      androidVersionDev,
      treasureChestEnabled,
    } = this.state;

    return (
      <Fragment>
        <UncontrolledPopover popperClassName={`popover`} placement="right" trigger="focus" target="admin-help-button-settings">
          <PopoverBody className="popover-body">
            The admin can set up the minimum version of the mobile app for the prod and dev versions. 
            <br /><br />
            The setting of Treasure Chest is related to the draugiem.lv yearly Advent event with a reward to everyone who opens the banner from their portal.
          </PopoverBody>
        </UncontrolledPopover>
        <div className="admin-page-content">
          <h2>
            Native App Update Settings
            <Button className="admin-help-button" id="admin-help-button-settings">
              ?
            </Button>
          </h2>
          <div style={{display: 'inline-block', width: '20%', marginRight: '10%'}}>
              <Label>
                iOS app
              </Label>
          
            <div>
              <Label for="iosVersion" style={{fontSize: '0.8rem'}}>
                Production Version
              </Label>
              <Input
                type="text"
                name="iosVersion"
                id="iosVersion"
                value={iosVersion}
                onChange={this.handleChange}
              />

              <Button color="primary" onClick={() => this.changeMobileVersion('ios')}>
                Change Mobile Version
              </Button>
            </div>
            <div>
              <Label for="iosVersionDev" style={{fontSize: '0.8rem'}}>
                Developer Version
              </Label>
              <Input
                type="text"
                name="iosVersionDev"
                id="iosVersionDev"
                value={iosVersionDev}
                onChange={this.handleChange}
              />

              <Button color="primary" onClick={() => this.changeMobileVersionDev('ios')}>
                Change Mobile Version
              </Button>
            </div>

          </div>
          <div style={{display: 'inline-block', width: '20%', marginRight: '10%'}}>
            <Label>
              Android app
            </Label>

            <div>
              <Label for="androidVersion" style={{fontSize: '0.8rem'}}>
                Production Version
              </Label>
              <Input
                type="text"
                name="androidVersion"
                id="androidVersion"
                value={androidVersion}
                onChange={this.handleChange}
              />

              <Button color="primary" onClick={() => this.changeMobileVersion('android')}>
                Change Mobile Version
              </Button>
            </div>
            <div>
              <Label for="androidVersionDev" style={{fontSize: '0.8rem'}}>
                Developer Version
              </Label>
              <Input
                type="text"
                name="androidVersionDev"
                id="androidVersionDev"
                value={androidVersionDev}
                onChange={this.handleChange}
              />

              <Button color="primary" onClick={() => this.changeMobileVersionDev('android')}>
                Change Mobile Version
              </Button>
            </div>

          </div>

          <div className="mt-3">
            <Label for="treasureChestEnabled">
              Treasure Chest Enabled
            </Label>
            <Input
              style={{ marginLeft: 25, position: 'relative' }}
              type="checkbox"
              name="treasureChestEnabled"
              id="treasureChestEnabled"
              checked={treasureChestEnabled}
              onChange={this.handleChange}
            />

            <Button style={{ marginLeft: 25 }} color="primary" onClick={this.changeTreasureChestEnabled}>
              Change Treasure Chest Enabled
            </Button>
          </div>

        </div>
      </Fragment>
    );
  }
}



const mapStateToProps = (state) => {
  return {
    // profanitiesList: state.admin.profanitiesList || {},
  };
};

const mapDispatchToProps = {
  // fetchProfanitiesList: getProfanitiesList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('admin')(Settings));
